import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
@Component({
  selector: 'app-visibility',
  templateUrl: './visibility.component.html',
  styleUrl: './visibility.component.scss'
})
export class VisibilityComponent implements OnInit {
    @Input() data: any;
    @Input() column: any;
    visible: boolean;

    constructor() {

    }

  ngOnInit() {

  }


}
